import ReactGA from 'react-ga4'
// @ts-ignore
// const ReactGA: GA4 = ga4.default

type ItemType = {
	item_id: string
	item_name: string
	item_category: string
	price: number
	quantity: number
	index?: number
}

export const initGa4 = (TRACKING_ID: string) => !ReactGA.isInitialized && ReactGA.initialize(TRACKING_ID)
export const isInitialized = () => ReactGA.isInitialized

export const pageView = (path: string, title: string) => ReactGA.isInitialized && ReactGA.send({ hitType: 'pageview', page: path, title: title })

export const beginCheckout = (price: number, items: Array<ItemType>) =>
	ReactGA.event('begin_checkout', {
		currency: 'USD',
		value: price,
		items,
	})

export const viewItem = (price: number, items: Array<ItemType>) =>
	ReactGA.event('view_item', {
		currency: 'USD',
		value: price,
		items,
	})

export const purchase = (transaction_id: string, price: number, items: Array<ItemType>) =>
	ReactGA.event('purchase', {
		transaction_id,
		currency: 'USD',
		value: price,
		items,
	})

export const checkoutProgress = (step: number, items?: Array<ItemType>) =>
	ReactGA.event('checkout_progress', {
		step,
		items,
	})
